import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import React from 'react';
import { reExportedColors } from '../1elements/';

const StyledMenu = styled(Menu)({
  '& .app-menu__paper': {
    borderRadius: 4,
    boxShadow: '0 0 5px #00000029'
  },

  '& .app-menu__text-paper': {
    display: 'inline-block',
    width: 'auto',
    minWidth: 0,
    maxWidth: 191
  },

  '& .app-menu__icon-list': {
    display: 'flex',
    maxWidth: 146,
    flexWrap: 'wrap',
    padding: 0
  },

  '& .app-menu__text-list': {
    width: '100%',
    boxSizing: 'border-box',
    padding: '6px 0'
  }
});

const StyledMenuItem = styled(MenuItem)({
  '&.app-menu__icon-item': {
    width: 30,
    height: 27,
    padding: '3px 2px',
    margin: 6,
    borderRadius: 4,
    justifyContent: 'center'
  },

  '&.app-menu__text-item': {
    width: '100%',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    padding: '7px 12px'
  },

  '&:hover': {
    backgroundColor: reExportedColors.HOVER
  }
});

const MenuPosition = {
  default: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  },
  left_center: {
    anchorOrigin: {
      vertical: 'center',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'center',
      horizontal: -3
    }
  }
};

export default function IMenu({
  children,
  position,
  anchorEl,
  open,
  handleClose,
  type
}) {
  const isIconMenu = type === 'icon';

  return (
    <StyledMenu
      {...MenuPosition[position]}
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      PaperProps={{
        className: `app-menu__paper ${
          isIconMenu ? 'app-menu__icon-paper' : 'app-menu__text-paper'
        }`
      }}
      MenuListProps={{
        className: isIconMenu ? 'app-menu__icon-list' : 'app-menu__text-list'
      }}
    >
      {React.Children.map(children, (child) => (
        <StyledMenuItem
          className={isIconMenu ? 'app-menu__icon-item' : 'app-menu__text-item'}
        >
          {child}
        </StyledMenuItem>
      ))}
    </StyledMenu>
  );
}
